import { DateRangePicker, DatePicker } from "@mantine/dates";
import "./datePicker.css";
import "dayjs/locale/tr";

const NewDatePicker = ({
  placeholder,
  label,
  rangePicker,
  value,
  size = "md",
  onChange,
  disabled,
  width,
  errorMessage = "",
  validate = "",
  marginBottom = 34,
  minDate = false,
}) => {
  return (
    <div style={{ width: width }} className={`mb-[${marginBottom}px] h-9 `}>
      {rangePicker ? (
        <DateRangePicker
          label={label}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          size={size}
          disabled={disabled}
          locale="tr"
          minDate={minDate && new Date()}
        />
      ) : (
        <div>
          <DatePicker
            placeholder={placeholder}
            label={label}
            value={value}
            disabled={disabled}
            onChange={onChange}
            locale="tr"
            size={"sm"}
            minDate={minDate && new Date()}
          />
          {errorMessage && validate && (
            <p className="text-[10px] text-right mr-2 text-red-500 mt-0.5 mb-1">
              {errorMessage || validate.toLocaleUpperCase()}
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default NewDatePicker;
